export const SELECTED_REGION = 'SELECTED_REGION';
